<script>
export default {
  name: 'Accordion',
  components: {
  },

  props: {
    card: {
      type: Boolean,
      default: false
    },

    multiples: {
      type: Boolean,
      default: false
    },

    modal: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {}
  },

  mounted () {
    if (!this.multiples) {
      this.$on('open', function (item) {
        for (let index = 0, lenght = this.$slots.default.length; index < lenght; index++) {
          const childComponent = this.$slots.default[index].componentInstance

          if (childComponent && item._uid !== childComponent._uid && childComponent.isOpen) {
            childComponent.close()
          }
        }
      })
    }
  }
}
</script>

<template>
  <div
    :class="{'accordion-card': card, 'accordion-modal': modal, 'theme-dark': dark}"
    class="accordion"
  >
    <div
      v-if="$slots.header"
      class="accordion-header"
    >
      <slot name="header" />
    </div>
    <slot />
  </div>
</template>

<style src="@/assets/styles/themes/default/accordion.css"></style>
